/**
 * Created by Florin David on 03/10/2016.
 */

const DEFAULTS = {
  NODE_ENV: 'development',
  API_URL: 'http://localhost:9000',
  LOGGER_APP: 'virtuallog',
  LOGGER_MODULE: 'virtuallog-web',
  LOGGER_SITE: 'local',
  LOGGER_URL: 'https://demo-api.virtuallog.io/logs',
  LOGGER_TOKEN: null,
  MODE: null as string | null,
}

// Use Vite's import.meta.glob for optional JSON import
const envFiles = import.meta.glob('../../env.json', { eager: true })
const ENV_JSON =
  (envFiles['../../env.json'] as { default: Record<string, unknown> })
    ?.default || {}

const env = {
  ...DEFAULTS,
  ...ENV_JSON,
}

/*
 * Export environment variables and 'checkEnv' function
 */
export default env
